import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useParams } from 'react-router-dom';

export type CatalogTemplateButtonProps = {
  name: string;
  to: string;
  current: boolean;
};

interface IUseCatalogTemplateLink {
  links: CatalogTemplateButtonProps[];
  linksMapper: (item: CatalogTemplateButtonProps, index: number) => JSX.Element;
}

export const useCatalogTemplateLink = (
  basePath: string = '/v2/campaigns'
): IUseCatalogTemplateLink => {
  const { t } = useTranslation();
  const { actionId = 0 } = useParams();
  const location = useLocation();

  const links: CatalogTemplateButtonProps[] = [
    {
      name: t('BEEFREE_TEMPLATES_GALLERY.gallery'),
      to: `${basePath}/catalogs/email/${actionId}`,
      current: location.pathname === `${basePath}/catalogs/email/${actionId}`,
    },
    {
      name: t('BEEFREE_TEMPLATES_GALLERY.myTemplates'),
      to: `${basePath}/catalogs/email/${actionId}/my-templates`,
      current: location.pathname === `${basePath}/catalogs/email/${actionId}/my-templates`,
    },
  ];

  const linksMapper = (item: CatalogTemplateButtonProps) => {
    const isCurrent = item.current;
    const linkClasses = classNames(
      isCurrent
        ? 'border-[#004DBC] text-[#004DBC] border-b-[5px] py-6 px-3'
        : 'border-transparent text-[#364365] hover:border-gray-300',
      'hover:text-gray-700 inline-flex text-sm py-6 px-3'
    );

    return (
      <NavLink key={item.name} className={linkClasses} to={item.to}>
        {item.name}
      </NavLink>
    );
  };

  return { links, linksMapper };
};
